export const googleMapsApiKey = "AIzaSyD4tuIZLWme4sMO7f0ezmPw5fkA5qBf6eU";


// WEBPACK FOOTER //
// ./src/app/googleMapsApiKey.ts